// Composable für Lieblingsteams - im localStorage gespeichert, bleibt über Seiten-Neuladen erhalten.
import { ref, watch } from 'vue'

const SPEICHER_SCHLUESSEL = 'tm-spielplan-favoriten'

function ladeFavoriten() {
  try {
    const roh = localStorage.getItem(SPEICHER_SCHLUESSEL)
    return roh ? new Set(JSON.parse(roh)) : new Set()
  } catch {
    return new Set() // localStorage evtl. nicht verfügbar (privater Modus etc.)
  }
}

// WICHTIG: State liegt auf Modul-Ebene (nicht innerhalb von useFavoriten()) - useFavoriten()
// wird an mehreren Stellen aufgerufen (MatchCard fürs Stern-Klicken, SpielplanWidget fürs
// Filtern) und muss sich dasselbe Set teilen. Vorher hatte JEDER Aufruf sein eigenes,
// unabhängiges Set (nur bei Seiten-Neuladen über localStorage synchronisiert) - ein Klick auf
// den Stern in MatchCard aktualisierte also nicht das Set, das der "Nur Favoriten"-Filter las.
const favoriten = ref(ladeFavoriten())

watch(favoriten, (neu) => {
  try {
    localStorage.setItem(SPEICHER_SCHLUESSEL, JSON.stringify([...neu]))
  } catch {
    // ignorieren, falls Speichern fehlschlägt (z.B. Safari privater Modus)
  }
}, { deep: true })

export function useFavoriten() {
  function istFavorit(teamId) {
    return teamId != null && favoriten.value.has(teamId)
  }

  function toggleFavorit(teamId) {
    if (teamId == null) return
    if (favoriten.value.has(teamId)) favoriten.value.delete(teamId)
    else favoriten.value.add(teamId)
  }

  return { favoriten, istFavorit, toggleFavorit }
}